/** Matches Cyberdyne CitizenPortalConfigService.validateRequest URL rules. */
export const PORTAL_HTTP_URL_PATTERN = /^https?:\/\/.+/i;

export const PORTAL_HTTP_URL_MESSAGE = 'Use an absolute URL starting with http:// or https://.';

export const PORTAL_FOOTER_URL_FIELDS = [
  'contactUsUrl',
  'facebookUrl',
  'xUrl',
  'instagramUrl',
  'youtubeUrl',
  'linkedinUrl',
] as const;

export type PortalFooterUrlField = typeof PORTAL_FOOTER_URL_FIELDS[number];

const PORTAL_URL_MAX_LENGTH = 1024;

export function validatePortalHttpUrl(value: string | undefined | null): string | null {
  const trimmed = (value ?? '').trim();

  if (!trimmed) {
    return null;
  }

  if (trimmed.length > PORTAL_URL_MAX_LENGTH) {
    return `Keep this under ${PORTAL_URL_MAX_LENGTH} characters.`;
  }

  if (!PORTAL_HTTP_URL_PATTERN.test(trimmed)) {
    return PORTAL_HTTP_URL_MESSAGE;
  }

  return null;
}

export function validatePortalFooterUrlFields(
  form: Record<PortalFooterUrlField, string>
): Partial<Record<PortalFooterUrlField, string>> {
  const fieldErrors: Partial<Record<PortalFooterUrlField, string>> = {};

  PORTAL_FOOTER_URL_FIELDS.forEach((field) => {
    const error = validatePortalHttpUrl(form[field]);
    if (error) {
      fieldErrors[field] = error;
    }
  });

  return fieldErrors;
}
